import React from 'react';
import './../../../core/style/TechnicalTable.css';

const TechnicalTable = ({ data, variant = "primary" }) => {
  return (
    <div className={`table-container ${variant}`} id='specs'>
      <h2 className="table-title">{data.title}</h2>
      <div className="table-responsive">
        <table className="busan-technical-table">
          <thead>
            <tr>
              {data.headers.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.rows.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {Array.isArray(row) ? (
                  row.map((cell, cellIndex) => <td key={cellIndex}>{cell}</td>)
                ) : (
                  <>
                    <td className="spec-label">{row.label}</td>
                    <td className="spec-unit">{row.unit}</td>
                    {row.values.map((val, i) => <td key={i}>{val}</td>)}
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TechnicalTable;